import { createIntlComparer, DEFAULT_LOCALES } from '../services/utils'
import { FeathersModel } from './feathersModel'

/**
 * Model representing an assistant in the calendar view
 * Extends FeathersModel for basic CRUD operations
 */
export class CalendarAssistant extends FeathersModel {
  static serviceName = 'features/assistant-availabilities-calendar/assistants'
  static intlSortComparer = createIntlComparer(DEFAULT_LOCALES, {
    sensitivity: 'accent',
  })
  private TAG = 'AssistantCalendar'
  // Basic assistant information
  firstName: string
  lastName: string
  keyCoordinatorWorkgroupId: number
  genderId: number
  contractTypesIds: [number]

  constructor(public id: number = null) {
    super(id)
  }

  getFullName(): string {
    return `${this.lastName} ${this.firstName}`
  }
}
